import "wicg-inert/dist/inert.js";
import "focus-visible";

(window as any).global = window;
